export const isLoadFullyDelivered = (loadId, shipmentDetails, dropDetails) => {
  const load = shipmentDetails.find((detail) => detail.SK.includes(`LID#${loadId}`));
  if (!load) {
    return false;
  }

  const deliveredTotals = new Map();
  dropDetails.forEach((dropDetail) => {
    const dropLoadId = dropDetail.SK.split('#LID#')[1];
    if (dropLoadId !== loadId || !Array.isArray(dropDetail.DROPS)) {
      return;
    }

    dropDetail.DROPS.forEach((drop) => {
      const quantity = Number(drop.ActualDischargeQty) || 0;
      deliveredTotals.set(drop.Product, (deliveredTotals.get(drop.Product) || 0) + quantity);
    });
  });

  return load.Products.every((product) => {
    const ambientQuantity = Number.parseInt(product.QuantityAmbient, 10);
    const deliveredQuantity = deliveredTotals.get(product.Name) || 0;
    return Number.isFinite(ambientQuantity) && deliveredQuantity >= ambientQuantity;
  });
};